import React from "react"
import { useNavigate } from "react-router-dom"
import {
    HeaderContainer,
    BackButtonContainer,
    BackButtonText,
    PageTitle,
} from "QuorumGrassroots/widgets/ReusableComponents/CampaignSubpageHeader/styles"
import { FilterButton } from "QuorumGrassroots/widgets/ReusableComponents/FilterButton/FilterButton"
import { FilterState } from "QuorumGrassroots/widgets/ReusableComponents/FilterButton/FilterButton.helper"

interface CampaignSubpageHeaderProps {
    title: string
    backUrl?: string
    dataCy?: string
    showFilterButton?: boolean
    showTypeFilter?: boolean
    onFiltersChange?: (filters: FilterState) => void
    withExtraMarginBottom?: boolean
}

export const CampaignSubpageHeader: React.FC<CampaignSubpageHeaderProps> = ({
    title,
    backUrl,
    dataCy,
    showFilterButton,
    showTypeFilter,
    onFiltersChange,
    withExtraMarginBottom,
}) => {
    const navigate = useNavigate()

    const handleBackClick = () => {
        if (backUrl) {
            navigate(backUrl)
        } else {
            navigate(-1)
        }
    }

    const handleBackKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            e.stopPropagation()
            handleBackClick()
        }
    }

    const handleBackKeyUp = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        // Prevent native click on keyup after manual activation above
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    return (
        <HeaderContainer data-cy={dataCy} withExtraMarginBottom={withExtraMarginBottom}>
            <BackButtonContainer
                type="button"
                onClick={handleBackClick}
                onKeyDown={handleBackKeyDown}
                onKeyUp={handleBackKeyUp}
                aria-label="Go back"
                data-cy={`${dataCy}-back-button`}
            >
                <i className="fa fa-arrow-left" aria-hidden="true" />
                <BackButtonText>Back</BackButtonText>
            </BackButtonContainer>
            <PageTitle>{title}</PageTitle>
            {showFilterButton && <FilterButton showTypeFilter={showTypeFilter} onFiltersChange={onFiltersChange} />}
        </HeaderContainer>
    )
}
